<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px">
  <polygon fill="currentColor" points="5 6 4 7 8 11 12 7 11 6 8 9 5 6"/>
</svg>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/IconArrowDown.vue